import { forwardRef } from "react";
import {
  GridColumnHeaderParams,
  useGridApiContext,
  useGridRootProps,
} from "@mui/x-data-grid-pro";
import { useSelectedRows } from "src/Pages/Company/Pending/PendingBenefits/SelectedRowsProvider/hooks";
import { IGroupedWaitingRoom } from "src/Pages/Company/Pending/PendingBenefits/types";

export const CustomHeaderCheckbox = forwardRef<
  HTMLInputElement,
  GridColumnHeaderParams<IGroupedWaitingRoom>
>((props, ref) => {
  const { field, colDef, ...other } = props;
  const rootProps = useGridRootProps();
  const apiRef = useGridApiContext();

  const rows = apiRef.current.getRowModels();

  const { getAllRowsState, handleSelectAllRows } = useSelectedRows();
  const { isChecked, isIndeterminate } = getAllRowsState(
    [...rows].map(([, row]) => row as IGroupedWaitingRoom)
  );

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    handleSelectAllRows(
      [...rows].map(([, row]) => row as IGroupedWaitingRoom),
      event.target.checked
    );
  };

  return (
    <rootProps.slots.baseCheckbox
      checked={isChecked && !isIndeterminate}
      onChange={handleChange}
      indeterminate={isIndeterminate}
      {...rootProps.slotProps?.baseCheckbox}
      {...other}
      ref={ref as never}
    />
  );
});
